<nz-select
  [formControl]="formPart"
  nzShowSearch
  nzServerSearch
  nzAllowClear
  nzPlaceHolder="Select a buyer or type a seat ID"
  [attr.id]="selectId"
  [attr.data-testid]="selectId ?? 'buyerDSPSeatID'"
  [nzCustomTemplate]="selectedBuyerTpl"
  [nzLoading]="isLoading"
  (nzOnSearch)="onSearch($event)"
  (nzScrollToBottom)="onScrollToBottom()">
  <nz-option *ngFor="let buyer of buyers"
             nzCustomContent
             [nzLabel]="buyerLabel(buyer)"
             [nzValue]="buyer.id">
    {{ buyerLabel(buyer) }}
    <span *ngIf="buyer.custom" class="custom-seat-tag" data-testid="ttd-custom-seat-tag-option">Manually entered</span>
  </nz-option>
  <nz-option *ngIf="customBuyer && !isLoading"
             nzCustomContent
             [nzLabel]="customBuyer.id"
             [nzValue]="customBuyer.id">
    <span data-testid="ttd-use-custom-seat-option">+ Use <b>{{ customBuyer.id }}</b> as seat ID</span>
  </nz-option>
</nz-select>
<ng-template #selectedBuyerTpl let-selected>
  {{ selected.nzLabel }}
  <span *ngIf="isCustomBuyerSelected" class="custom-seat-tag" data-testid="ttd-custom-seat-tag-selected">Manually entered</span>
</ng-template>
<span *ngIf="isSyncHintVisible" class="custom-seat-hint" data-testid="ttd-custom-seat-hint">
  Verified by TTD on sync
</span>
